<template>
  <div>
    <div
      v-if="loading === true"
      class="spinner-grow text-primary"
      style="margin-top: 15%;margin-left: 45%;"
    />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :selectedPage="tab"
      @refresh="renderTable"
      @choosenObject="getEditedObject($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
        v-if="tab === 'phases'"
      :phase="editedItem"
      @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../shared/tables/BasicTable.vue'
import Edit from './edit.vue'
import stagePhasesService from '@/services/settings/stagePhasesService'

export default {
  components: {
    Edit,
    BasicTable,
  },
  props: ['tab'],
  data() {
    return {
      loading: false,
      choosenTab: '',
      editedItem: '',
      columns: [
        {
          label: 'Phase',
          field: 'title',
        },
        {
          label: 'Stage',
          field: 'stage.name',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getStages()
  },
  mounted() {
    this.$watch(() => this.tab, val => {
      console.log('Tabb====>', val)
      this.choosenTab = val
    })
  },
  methods: {
    getStages() {
      this.loading = true
      stagePhasesService.index().then(response => {
        this.loading = false
        this.rows = response.data.data
      })
    },
    getEditedObject(obj) {
      this.editedItem = obj
    },

    renderTable() {
      this.getStages()
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
